// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function() {
    //
});
